import { isAdminRole, isFleetOwnerRole, type UserRole } from '@ubus/shared';

/** Default landing path by role (English ops portal). */
export function homePathForRole(role: UserRole | null | undefined): string {
  // Platform → 运营看板; fleet → week overview (CONF-20260719)
  if (isAdminRole(role)) return '/dashboard';
  if (isFleetOwnerRole(role)) return '/schedule-overview';
  return '/dashboard';
}
